<template>
  <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="handleClose"
      append-to-body
      width="80%"
      :close-on-click-modal="false"
      class="my-dialog-detail"
  >
    <div class="wh100">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="工地详细信息" name="first">
        <BuildingInfo v-if="this.activeName==='first'" :building-info="buildingInfo"></BuildingInfo>
        </el-tab-pane>
        <el-tab-pane label="站点信息" name="second">
			  <StationList v-if="this.activeName==='second'" :building-info="buildingInfo"></StationList>
        </el-tab-pane>
        <el-tab-pane label="报警信息" name="third">
		  	<AlarmList v-if="this.activeName==='third'" :building-info="buildingInfo" style="height: 33vw"></AlarmList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import BuildingInfo from "@/views/BasicInformation/components/BuildingInfo";
import StationList from "@/views/BasicInformation/components/StationList";
import AlarmList from "@/views/BasicInformation/components/AlarmList";
export default {
  name: "BuildingDetailManage",
  props: ["options","title"],
  components: {BuildingInfo,StationList,AlarmList},
  data() {
    return {
      dialog:{
        title:this.title,
        visible:false,
      },
      activeName:"first",
      buildingInfo:"",
      buildingId:this.options.id,
    }
  },
  methods: {
    init() {
      this.dialog.visible = true;
      this.buildingInfo=this.options;
      if (!this.buildingInfo.contactsAndPhone) {
        let cPhone = "-";
        let cPeople = "-"
        if (this.buildingInfo.contactsPhone) {
          cPhone = this.buildingInfo.contactsPhone;
        }
        if (this.buildingInfo.contacts) {
          cPeople = this.buildingInfo.contacts;
        }
        this.buildingInfo.contactsAndPhone=cPeople+"("+cPhone+")"
      }
      if (!this.buildingInfo.hbContactsAndPhone) {
        let phone = "-";
        let people = "-"
        if (this.buildingInfo.hbContactsPhone) {
          phone = this.buildingInfo.hbContactsPhone;
        }
        if (this.buildingInfo.hbContacts) {
          people = this.buildingInfo.hbContacts;
        }
        this.buildingInfo.hbContactsAndPhone=people+"("+phone+")";
      }
    },
    handleClick(tab, event) {

    },
    //关闭弹框
    handleClose() {
      this.dialog.visible = false;
      this.$emit("closeModal");
    },
  },
  mounted() {
  },
  watch: {}
}
</script>

<style scoped lang="less">
/deep/ .my-dialog .el-dialog .el-dialog__body{
  padding-top: 5px !important;
}


</style>